import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "@/context/UserContext";
import { AuthRouteFallback } from "@/routes/RouteFallback";

/** Restricts /management/* to Manager accounts inside the company AppLayout. */
export function ManagerManagementRoute() {
  const { userDetails } = useUserContext();

  if (userDetails === undefined) {
    return <AuthRouteFallback />;
  }

  if (userDetails?.role !== "MANAGER") {
    return <Navigate to="/my-discovery" replace />;
  }

  return <Outlet />;
}
